import React from 'react';
import './Brain.css';

const ACTIVE = '#f37979',
  INACTIVE = '#ff9797',
  ELLIPSES = [
    'translate(304.91 134.38)',
    'translate(221.48 149.73)',
    'translate(212.5 320.83)',
    'translate(296.55 211.74)',
    'translate(212.5 73.76)',
    'translate(56.76 211.74)',
    'translate(41.41 134.38)',
    'translate(124.84 63.73)',
    'translate(124.84 149.73)',
    'translate(124.84 313.47)',
  ];

const Brain = ({ index, update }) => {
  const left = index - 4 > 0;

  return (
    <>
      <div className="brain">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="374.991"
          height="386.377"
          viewBox="0 0 374.991 386.377"
        >
          <defs>
            <clipPath id="clip-path">
              <path
                id="Path_11977"
                data-name="Path 11977"
                d="M405,155.188H588.991V541.565H405Zm0,0"
                transform="translate(-405 -155.188)"
                fill="#ccf"
              />
            </clipPath>
            <clipPath id="clip-path-2">
              <path
                id="Path_11977-2"
                data-name="Path 11977"
                d="M588.991,155.188H405V541.565H588.991Zm0,0"
                transform="translate(-405 -155.188)"
                fill="#ccf"
              />
            </clipPath>
            <filter
              id="button_10"
              x="121.838"
              y="311.472"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="button_9"
              x="121.838"
              y="147.733"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur-2" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur-2" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="button_8"
              x="121.838"
              y="61.733"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur-3" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur-3" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="button_7"
              x="38.406"
              y="132.375"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur-4" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur-4" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="button_6"
              x="53.765"
              y="209.739"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur-5" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur-5" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="button_5"
              x="209.504"
              y="71.756"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur-6" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur-6" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="button_4"
              x="293.555"
              y="209.739"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur-7" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur-7" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="button_3"
              x="209.504"
              y="318.83"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur-8" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur-8" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="button_2"
              x="218.481"
              y="147.733"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur-9" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur-9" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="button_1"
              x="301.913"
              y="132.375"
              width="42.716"
              height="42.716"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dx="3" dy="4" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="2" result="blur-10" />
              <feFlood flood-color="#09093f" flood-opacity="0.149" />
              <feComposite operator="in" in2="blur-10" />
              <feComposite in="SourceGraphic" />
            </filter>
          </defs>
          <g id="brain" transform="translate(-877.828 -352.545)">
            <g
              id="mm_2_"
              data-name="mm (2)"
              transform="translate(713.212 197.357)"
            >
              <path
                id="left"
                data-name="bgcolor left"
                d="M308.834,269.519a46.43,46.43,0,0,1-27.16-.65c4.553,23.211-9.166,46.419-32,52.889a5.774,5.774,0,1,1-3.149-11.111c17.939-5.083,28.323-24.106,23.146-42.4a35.329,35.329,0,0,0-3.406-8.046,45.052,45.052,0,0,1-15.954-34.394,5.777,5.777,0,0,1,11.555,0A33.6,33.6,0,0,0,274.431,252a34.989,34.989,0,0,0,31.28,6.409,5.772,5.772,0,1,1,3.123,11.114ZM284.007,427.156s0,0,.006,0c.126.051.252.094.376.154.152.066.263.112.367.161h0a34.192,34.192,0,0,0,23.034.854,5.776,5.776,0,1,1,3.527,11,45.392,45.392,0,0,1-12.283,2.121c-.544.017-1.089.029-1.63.029a45.239,45.239,0,0,1-17.08-3.338c-.023-.008-.166-.068-.189-.077-.066-.029-.132-.06-.2-.092-.095-.037-.192-.078-.269-.114-.054-.021-.109-.04-.161-.063a33.292,33.292,0,0,0-41.867,15.24,36.049,36.049,0,0,0-3.323,8.765,5.778,5.778,0,0,1-11.243-2.67,47.6,47.6,0,0,1,4.406-11.6,45.3,45.3,0,0,1,34.312-23.44,44.354,44.354,0,0,1-9.412-25.7,5.774,5.774,0,0,1,5.575-5.971c.066,0,.132,0,.2,0a5.774,5.774,0,0,1,5.77,5.573A33.251,33.251,0,0,0,284.007,427.156ZM322.6,160.7c-9.418-4.515-22.793-4.464-35.769.143-11.154,3.954-20.633,10.963-26.013,19.08l11.22,18.444a5.778,5.778,0,0,1-9.879,6l-11.008-18.1a49.5,49.5,0,0,0-22.569,12.028c-15.67,14.212-20.341,31.2-12.3,43.858l18.567,5.332a5.775,5.775,0,1,1-3.189,11.1l-19.214-5.515c-14.4,3.125-27.022,15.274-33.12,32.065-6.57,18.1-4.452,36.887,5.023,46.488h29.532a5.775,5.775,0,1,1,0,11.55H183.7c-8.129,9-11.862,24.48-9.558,40.368,2.573,17.627,12.079,32.426,23.893,37.514l14.415-3.424a5.774,5.774,0,1,1,2.674,11.235l-13.719,3.26c-5.817,11.868-2.645,30,8.143,45.107,10.822,15.166,26.784,23.9,39.753,22.08l9.635-20.779a5.777,5.777,0,0,1,10.484,4.857l-9.051,19.518c19.286,16.1,43.285,19.257,59.52,7.438a37.827,37.827,0,0,0,12.9-16.834V346.422c-5.584,6.7-11.487,11.4-17.9,14.272,1.925,6.066,2.057,13.532.513,23.572a5.78,5.78,0,0,1-5.7,4.9,5.527,5.527,0,0,1-.885-.069,5.773,5.773,0,0,1-4.834-6.582c1.673-10.87,1.123-17.455-1.828-22.016-3.095-4.8-9.6-8.217-20.49-10.768a5.774,5.774,0,1,1,2.633-11.243c11.6,2.716,19.6,6.627,24.744,12.145,8.516-3.4,16.163-11.369,23.753-24.684V170.924c-2.189-5.407-6.69-8.544-10.186-10.223"
                transform="translate(3.484 10.967)"
                fill="#e0e0ff"
                className={`${left ? 'bg-active' : 'bg-inactive'}`}
              />
              <path
                id="right"
                data-name="bgcolor right"
                d="M197.422,269.519a46.43,46.43,0,0,0,27.16-.65c-4.553,23.211,9.166,46.419,32,52.889a5.774,5.774,0,1,0,3.149-11.111c-17.939-5.083-28.323-24.106-23.146-42.4a35.329,35.329,0,0,1,3.406-8.046,45.052,45.052,0,0,0,15.954-34.394,5.777,5.777,0,0,0-11.555,0A33.6,33.6,0,0,1,231.825,252a34.989,34.989,0,0,1-31.28,6.409,5.772,5.772,0,1,0-3.123,11.114Zm24.827,157.637s0,0-.006,0c-.126.051-.252.094-.376.154-.152.066-.263.112-.367.161h0a34.192,34.192,0,0,1-23.034.854,5.776,5.776,0,1,0-3.527,11,45.392,45.392,0,0,0,12.283,2.121c.544.017,1.089.029,1.63.029a45.239,45.239,0,0,0,17.08-3.338c.023-.008.166-.068.189-.077.066-.029.132-.06.2-.092.095-.037.192-.078.269-.114.054-.021.109-.04.161-.063a33.292,33.292,0,0,1,41.867,15.24,36.049,36.049,0,0,1,3.323,8.765,5.778,5.778,0,0,0,11.243-2.67,47.6,47.6,0,0,0-4.406-11.6,45.3,45.3,0,0,0-34.312-23.44,44.354,44.354,0,0,0,9.412-25.7,5.774,5.774,0,0,0-5.575-5.971c-.066,0-.132,0-.2,0a5.774,5.774,0,0,0-5.77,5.573A33.251,33.251,0,0,1,222.249,427.156ZM183.658,160.7c9.418-4.515,22.793-4.464,35.769.143,11.154,3.954,20.633,10.963,26.013,19.08l-11.22,18.444a5.778,5.778,0,0,0,9.879,6l11.008-18.1a49.5,49.5,0,0,1,22.569,12.028c15.67,14.212,20.341,31.2,12.3,43.858l-18.567,5.332a5.775,5.775,0,1,0,3.189,11.1l19.214-5.515c14.4,3.125,27.022,15.274,33.12,32.065,6.57,18.1,4.452,36.887-5.023,46.488H292.381a5.775,5.775,0,1,0,0,11.55h30.174c8.129,9,11.862,24.48,9.558,40.368-2.573,17.627-12.079,32.426-23.893,37.514l-14.415-3.424a5.774,5.774,0,1,0-2.674,11.235l13.719,3.26c5.817,11.868,2.645,30-8.143,45.107-10.822,15.166-26.784,23.9-39.753,22.08l-9.635-20.779a5.777,5.777,0,0,0-10.484,4.857l9.051,19.518c-19.286,16.1-43.285,19.257-59.52,7.438a37.827,37.827,0,0,1-12.9-16.834V346.422c5.584,6.7,11.487,11.4,17.9,14.272-1.925,6.066-2.057,13.532-.513,23.572a5.78,5.78,0,0,0,5.7,4.9,5.527,5.527,0,0,0,.885-.069,5.773,5.773,0,0,0,4.834-6.582c-1.673-10.87-1.123-17.455,1.828-22.016,3.095-4.8,9.6-8.217,20.49-10.768a5.774,5.774,0,1,0-2.633-11.243c-11.6,2.716-19.6,6.627-24.744,12.145-8.516-3.4-16.163-11.369-23.753-24.684V170.924c2.189-5.407,6.69-8.544,10.186-10.223"
                transform="translate(194.484 10.967)"
                fill="#e0e0ff"
                className={`${!left ? 'bg-active' : 'bg-inactive'}`}
              />
              <g id="Group_14092" data-name="Group 14092">
                <g
                  id="Group_14091"
                  data-name="Group 14091"
                  transform="translate(355.617 155.188)"
                  clip-path="url(#clip-path)"
                >
                  <path
                    id="Path_11976"
                    data-name="Path 11976"
                    d="M418.817,515.493c1.857,4.1,4.631,5.476,11.466,8.43l1.016.439c16.035,6.958,41.269,5.516,61.487-13.386a6.561,6.561,0,0,1,6.115-1.555c13.021,3.387,30.027-5.331,41.352-21.2,11.195-15.685,14.077-34.639,7.016-46.106a6.527,6.527,0,0,1,3.368-9.581c12.188-4.349,22.139-19.376,24.76-37.4,2.436-16.745-1.924-33.008-11.1-41.434a6.537,6.537,0,0,1,.09-9.708c10.174-8.983,12.6-28.155,5.906-46.619-6.158-16.951-19.049-29.111-33.64-31.73a6.532,6.532,0,0,1-4.106-10.31c9.167-12.419,4.788-29.778-11.156-44.231-7.7-7-16.8-11.4-25.608-12.387a6.539,6.539,0,0,1-5.046-3.427c-4.815-9.062-14.962-17.055-27.145-21.379-16.871-5.984-32.27-7.336-40.183-3.538a9.04,9.04,0,0,0-4.588,4.33Zm32.142,25.939a62.3,62.3,0,0,1-24.868-5.083l-1-.43c-7.717-3.335-15.006-6.485-18.931-16.819a6.567,6.567,0,0,1-.424-2.318V173.439a6.6,6.6,0,0,1,.36-2.139,21.978,21.978,0,0,1,11.641-12.71c11.272-5.418,29.579-4.327,50.23,3,14.139,5.025,25.832,13.9,32.611,24.628,10.424,1.909,20.82,7.231,29.6,15.205,17.99,16.309,24.338,36.911,17.372,53.748,15.47,5.888,28.469,19.687,35.027,37.741,7.619,21,5.51,42.544-4.969,56,9.342,11.834,13.417,29.615,10.728,48.106-2.908,19.963-13.116,36.73-26.782,44.763,5.789,15.678,1.9,36.447-10.657,54.03-13.693,19.2-34.044,29.677-51.723,27-14.152,12.178-31.389,18.632-48.22,18.632"
                    transform="translate(-405.157 -155.188)"
                    fill="#ccf"
                  />
                </g>
                <path
                  id="Path_11978"
                  data-name="Path 11978"
                  d="M502.8,228.188a6.542,6.542,0,0,1-5.581-9.932l13.009-21.388a6.538,6.538,0,0,1,11.177,6.789L508.4,225.044a6.547,6.547,0,0,1-5.6,3.144"
                  transform="translate(-68.851 -8.22)"
                  fill="#ccf"
                />
                <path
                  id="Path_11979"
                  data-name="Path 11979"
                  d="M545.755,297.952a6.535,6.535,0,0,1-1.8-12.815l20.565-5.91a6.535,6.535,0,1,1,3.614,12.56l-20.562,5.907a6.51,6.51,0,0,1-1.813.258"
                  transform="translate(-78.011 -26.402)"
                  fill="#ccf"
                />
                <path
                  id="Path_11980"
                  data-name="Path 11980"
                  d="M602.163,406.605H570.332a6.533,6.533,0,1,1,0-13.066h31.831a6.533,6.533,0,1,1,0,13.066"
                  transform="translate(-83.253 -50.839)"
                  fill="#ccf"
                />
                <path
                  id="Path_11981"
                  data-name="Path 11981"
                  d="M586.643,519.391a6.691,6.691,0,0,1-1.525-.178l-16.189-3.854a6.536,6.536,0,1,1,3.03-12.716l16.189,3.857a6.534,6.534,0,0,1-1.506,12.891"
                  transform="translate(-83.276 -74.072)"
                  fill="#ccf"
                />
                <path
                  id="Path_11982"
                  data-name="Path 11982"
                  d="M517.354,612.162a6.533,6.533,0,0,1-5.934-3.79l-10.838-23.389a6.538,6.538,0,0,1,11.868-5.489l10.835,23.386a6.535,6.535,0,0,1-5.931,9.281"
                  transform="translate(-69.641 -89.692)"
                  fill="#ccf"
                />
                <path
                  id="Path_11983"
                  data-name="Path 11983"
                  d="M461.045,521.189c-.541,0-1.082-.013-1.626-.031a46.464,46.464,0,0,1-12.452-2.136,6.536,6.536,0,0,1,3.958-12.458,33.389,33.389,0,0,0,8.946,1.533,32.8,32.8,0,0,0,23.5-8.675,31.785,31.785,0,0,0,10.341-22.434,6.539,6.539,0,0,1,13.07.449,44.755,44.755,0,0,1-14.548,31.594,45.763,45.763,0,0,1-31.188,12.157"
                  transform="translate(-57.362 -67.293)"
                  fill="#ccf"
                />
                <path
                  id="Path_11984"
                  data-name="Path 11984"
                  d="M462.825,304.592a47.118,47.118,0,0,1-12.738-1.743,6.535,6.535,0,1,1,3.528-12.584,34.072,34.072,0,0,0,9.21,1.26c18.512,0,33.57-14.828,33.57-33.054a6.539,6.539,0,0,1,13.079,0c0,25.43-20.927,46.121-46.649,46.121"
                  transform="translate(-57.98 -20.636)"
                  fill="#ccf"
                />
                <path
                  id="Path_11985"
                  data-name="Path 11985"
                  d="M519.16,363.549a6.551,6.551,0,0,1-1.788-.249c-24.425-6.929-38.6-32.728-31.588-57.515a47.2,47.2,0,0,1,5.135-11.8,6.537,6.537,0,0,1,11.167,6.8,34.324,34.324,0,0,0-3.718,8.55c-5.049,17.861,5.08,36.428,22.575,41.391a6.534,6.534,0,0,1-1.783,12.821"
                  transform="translate(-66.232 -28.936)"
                  fill="#ccf"
                />
                <path
                  id="Path_11986"
                  data-name="Path 11986"
                  d="M536.956,554.4a6.542,6.542,0,0,1-6.361-5.055,34.414,34.414,0,0,0-3.242-8.547,32.41,32.41,0,0,0-40.825-14.852c-.12.052-.24.1-.354.157l-.144.058a6.535,6.535,0,1,1-5.489-11.862l.581-.255c.07-.031.178-.08.252-.111a45.451,45.451,0,0,1,57.47,20.633,47.3,47.3,0,0,1,4.49,11.809,6.542,6.542,0,0,1-4.889,7.852,6.685,6.685,0,0,1-1.488.172"
                  transform="translate(-64.685 -75.772)"
                  fill="#ccf"
                />
                <path
                  id="Path_11987"
                  data-name="Path 11987"
                  d="M443.692,423.9a6.621,6.621,0,0,1-1.591-.2c-13.653-3.4-24.944-13.826-35.525-32.789A6.536,6.536,0,0,1,418,384.551c8.7,15.589,17.37,24,27.277,26.477a6.533,6.533,0,0,1-1.58,12.873"
                  transform="translate(-49.543 -48.206)"
                  fill="#ccf"
                />
                <path
                  id="Path_11988"
                  data-name="Path 11988"
                  d="M448.523,454.341a6.54,6.54,0,0,1-6.456-5.547c-3.488-22.7.559-39.3,31.628-46.567a6.536,6.536,0,1,1,2.978,12.729c-21.776,5.086-24.609,12.772-21.681,31.855a6.533,6.533,0,0,1-5.47,7.452,6.982,6.982,0,0,1-1,.077"
                  transform="translate(-57.068 -52.655)"
                  fill="#ccf"
                />
              </g>
              <g
                id="Group_14093"
                data-name="Group 14093"
                transform="translate(164.617 155.188)"
              >
                <g
                  id="Group_14091-2"
                  data-name="Group 14091"
                  clip-path="url(#clip-path-2)"
                >
                  <path
                    id="Path_11976-2"
                    data-name="Path 11976"
                    d="M576.076,515.493c-1.857,4.1-4.631,5.476-11.466,8.43l-1.016.439c-16.036,6.958-41.269,5.516-61.487-13.386a6.561,6.561,0,0,0-6.115-1.555c-13.021,3.387-30.027-5.331-41.352-21.2-11.195-15.685-14.077-34.639-7.016-46.106a6.527,6.527,0,0,0-3.368-9.581c-12.188-4.349-22.139-19.376-24.76-37.4-2.436-16.745,1.924-33.008,11.1-41.434a6.537,6.537,0,0,0-.09-9.708c-10.174-8.983-12.6-28.155-5.906-46.619,6.158-16.951,19.049-29.111,33.64-31.73a6.532,6.532,0,0,0,4.106-10.31c-9.167-12.419-4.788-29.778,11.156-44.231,7.7-7,16.8-11.4,25.608-12.387a6.539,6.539,0,0,0,5.046-3.427c4.815-9.062,14.962-17.055,27.145-21.379,16.871-5.984,32.27-7.336,40.183-3.538a9.04,9.04,0,0,1,4.588,4.33Zm-32.142,25.939A62.3,62.3,0,0,0,568.8,536.35l1-.43c7.717-3.335,15.006-6.485,18.93-16.819a6.567,6.567,0,0,0,.424-2.318V173.439a6.6,6.6,0,0,0-.359-2.139,21.979,21.979,0,0,0-11.641-12.71c-11.272-5.418-29.579-4.327-50.23,3-14.14,5.025-25.832,13.9-32.611,24.628-10.424,1.909-20.82,7.231-29.6,15.205-17.99,16.309-24.338,36.911-17.372,53.748-15.47,5.888-28.469,19.687-35.027,37.741-7.619,21-5.51,42.544,4.969,56-9.342,11.834-13.417,29.615-10.728,48.106,2.908,19.963,13.116,36.73,26.782,44.763-5.789,15.678-1.9,36.447,10.657,54.03,13.693,19.2,34.044,29.677,51.723,27,14.152,12.178,31.389,18.632,48.22,18.632"
                    transform="translate(-405.744 -155.188)"
                    fill="#ccf"
                  />
                </g>
                <path
                  id="Path_11978-2"
                  data-name="Path 11978"
                  d="M515.827,228.188a6.542,6.542,0,0,0,5.581-9.932L508.4,196.868a6.538,6.538,0,0,0-11.177,6.789l13.008,21.388a6.547,6.547,0,0,0,5.6,3.144"
                  transform="translate(-410.171 -163.408)"
                  fill="#ccf"
                />
                <path
                  id="Path_11979-2"
                  data-name="Path 11979"
                  d="M566.33,297.952a6.535,6.535,0,0,0,1.8-12.815l-20.565-5.91a6.535,6.535,0,1,0-3.614,12.56l20.562,5.907a6.51,6.51,0,0,0,1.813.258"
                  transform="translate(-494.466 -181.59)"
                  fill="#ccf"
                />
                <path
                  id="Path_11980-2"
                  data-name="Path 11980"
                  d="M570.336,406.605h31.831a6.533,6.533,0,1,0,0-13.066H570.336a6.533,6.533,0,1,0,0,13.066"
                  transform="translate(-549.639 -206.026)"
                  fill="#ccf"
                />
                <path
                  id="Path_11981-2"
                  data-name="Path 11981"
                  d="M570.435,519.391a6.691,6.691,0,0,0,1.525-.178l16.189-3.854a6.536,6.536,0,1,0-3.03-12.716L568.929,506.5a6.534,6.534,0,0,0,1.506,12.891"
                  transform="translate(-534.195 -229.26)"
                  fill="#ccf"
                />
                <path
                  id="Path_11982-2"
                  data-name="Path 11982"
                  d="M506.514,612.162a6.533,6.533,0,0,0,5.934-3.79l10.839-23.389a6.538,6.538,0,0,0-11.868-5.489l-10.835,23.386a6.535,6.535,0,0,0,5.931,9.281"
                  transform="translate(-414.62 -244.88)"
                  fill="#ccf"
                />
                <path
                  id="Path_11983-2"
                  data-name="Path 11983"
                  d="M488.148,521.189c.541,0,1.082-.013,1.626-.031a46.464,46.464,0,0,0,12.452-2.136,6.536,6.536,0,0,0-3.958-12.458,33.389,33.389,0,0,1-8.946,1.533,32.8,32.8,0,0,1-23.5-8.675,31.785,31.785,0,0,1-10.341-22.434,6.539,6.539,0,0,0-13.07.449,44.755,44.755,0,0,0,14.548,31.594,45.763,45.763,0,0,0,31.188,12.157"
                  transform="translate(-352.223 -222.481)"
                  fill="#ccf"
                />
                <path
                  id="Path_11984-2"
                  data-name="Path 11984"
                  d="M491.956,304.592a47.118,47.118,0,0,0,12.738-1.743,6.535,6.535,0,1,0-3.528-12.584,34.072,34.072,0,0,1-9.21,1.26c-18.512,0-33.57-14.828-33.57-33.054a6.539,6.539,0,0,0-13.079,0c0,25.43,20.927,46.121,46.649,46.121"
                  transform="translate(-357.193 -175.824)"
                  fill="#ccf"
                />
                <path
                  id="Path_11985-2"
                  data-name="Path 11985"
                  d="M490.531,363.549a6.551,6.551,0,0,0,1.788-.249c24.425-6.929,38.6-32.728,31.588-57.515a47.2,47.2,0,0,0-5.135-11.8,6.537,6.537,0,0,0-11.167,6.8,34.324,34.324,0,0,1,3.718,8.55c5.049,17.861-5.08,36.428-22.575,41.391a6.534,6.534,0,0,0,1.783,12.821"
                  transform="translate(-403.851 -184.124)"
                  fill="#ccf"
                />
                <path
                  id="Path_11986-2"
                  data-name="Path 11986"
                  d="M483.291,554.4a6.542,6.542,0,0,0,6.361-5.055,34.414,34.414,0,0,1,3.242-8.547,32.41,32.41,0,0,1,40.825-14.852c.12.052.24.1.354.157l.144.058a6.535,6.535,0,1,0,5.489-11.862l-.581-.255c-.07-.031-.178-.08-.252-.111a45.451,45.451,0,0,0-57.47,20.633,47.3,47.3,0,0,0-4.49,11.809,6.542,6.542,0,0,0,4.889,7.852,6.685,6.685,0,0,0,1.488.172"
                  transform="translate(-415.954 -230.96)"
                  fill="#ccf"
                />
                <path
                  id="Path_11987-2"
                  data-name="Path 11987"
                  d="M412.284,423.9a6.621,6.621,0,0,0,1.591-.2c13.653-3.4,24.944-13.826,35.525-32.789a6.536,6.536,0,0,0-11.419-6.364c-8.7,15.589-17.37,24-27.277,26.477a6.533,6.533,0,0,0,1.58,12.873"
                  transform="translate(-266.826 -203.394)"
                  fill="#ccf"
                />
                <path
                  id="Path_11988-2"
                  data-name="Path 11988"
                  d="M474.23,454.341a6.54,6.54,0,0,0,6.456-5.547c3.488-22.7-.559-39.3-31.628-46.567a6.536,6.536,0,1,0-2.978,12.729c21.776,5.086,24.609,12.772,21.681,31.855a6.533,6.533,0,0,0,5.47,7.452,6.982,6.982,0,0,0,1,.077"
                  transform="translate(-326.077 -207.843)"
                  fill="#ccf"
                />
              </g>
            </g>
            {ELLIPSES.map((item, itemIndex) => (
              <g
                key={`ellipse${itemIndex}`}
                transform="matrix(1, 0, 0, 1, 877.83, 352.55)"
                filter={`url(#button_${itemIndex + 1})`}
              >
                {index !== itemIndex && (
                  <circle
                    className="circle-effect"
                    r="25"
                    cx="15.358"
                    cy="15.358"
                    transform={item}
                    fill={INACTIVE}
                  >
                    <animate
                      attributeType="xml"
                      attributeName="r"
                      from="15.358"
                      to="20"
                      dur="1s"
                      repeatCount="indefinite"
                    />
                  </circle>
                )}
                <ellipse
                  className="mouse-point"
                  data-name={`button ${itemIndex + 1}`}
                  cx="15.358"
                  cy="15.358"
                  rx="10"
                  ry="10"
                  transform={item}
                  fill={index === itemIndex ? ACTIVE : INACTIVE}
                  onClick={() => update(itemIndex)}
                />
              </g>
            ))}
          </g>
        </svg>
      </div>
    </>
  );
};

export default Brain;
